import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {TraceResultObj} from "./App";
import CircularProgress from "@material-ui/core/CircularProgress";


const useStyles = makeStyles({
    table: {
        minWidth: 100,
    },
});

function createData(hop: string, host: string, ip: string, rtnn: string) {
    return { hop, host, ip, rtnn };
}



interface Props{
    result: Array<TraceResultObj>;
    traceRunning: boolean;
}

function MaterialTable(props: Props) {
    const classes = useStyles();
    const {result, traceRunning} = props;

    const rows = result.map(resultObj => {
        return createData(resultObj.hop, resultObj.host, resultObj.ip, resultObj.rtnn)
    })

    // const rows = [
    //     createData('1', "adm-b2-link.ip.twelve99.net", "1.1.1.1", "24ms"),
    //     createData('2', "adm-b2-link.ip.twelve99.net", "1.1.1.1", "24ms"),
    //     createData('3', "*", "n/a", "n/a"),
    //     createData('4', "adm-b2-link.ip.twelve99.net", "1.1.1.1", "24ms"),
    //     createData('5', "adm-b2-link.ip.twelve99.net", "1.1.1.1", "24ms"),
    //     createData('6', "adm-b2-link.ip.twelve99.net", "1.1.1.1", "24ms"),
    //     createData('7', "adm-b2-link.ip.twelve99.net", "1.1.1.1", "24ms"),
    //     createData('8', "adm-b2-link.ip.twelve99.net", "1.1.1.1", "24ms"),
    //     createData('9', "adm-b2-link.ip.twelve99.net", "1.1.1.1", "24ms"),
    //     createData('10', "adm-b2-link.ip.twelve99.net", "1.1.1.1", "24ms"),
    //     createData('11', "adm-b2-link.ip.twelve99.net", "1.1.1.1", "24ms"),
    //     createData('12', "*", "n/a", "n/a"),
    //     createData('13', "*", "n/a", "n/a"),
    //     createData('14', "*", "n/a", "n/a"),
    //     createData('15', "*", "n/a", "n/a"),
    // ];

        return (
            <>
                {traceRunning ? <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '85%', height: '500px', position: 'absolute'}}>
                    <CircularProgress size={60} color='secondary' />
                </div> : <span></span>}
            <TableContainer style={{filter: `${traceRunning ? 'blur(3px)' : 'blur(0px)'}`, background: `${traceRunning ? "rgba(255, 255, 255, .5)": "white"}`}} component={Paper}>
                <Table className={classes.table} size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell variant='head' size='medium'>Hop</TableCell>
                            <TableCell variant='head' size='medium' align="center">Host</TableCell>
                            <TableCell variant='head' size='medium' align="center">IP</TableCell>
                            <TableCell variant='head' size='medium' align="center">RTNN</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row: any) => (
                            <TableRow key={row.hop}>
                                <TableCell component="th" scope="row">
                                    {row.hop}
                                </TableCell>
                                <TableCell align='center' scope="row">
                                    {row.host}
                                </TableCell>
                                <TableCell align="center">{row.ip}</TableCell>
                                <TableCell align="center">{row.rtnn}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
                </>
        );
}

export default React.memo(MaterialTable)
